import { css } from '@emotion/core'
import styled from '@emotion/styled'

import { colors, Link, NativeLink, palette, spacing, typography } from 'main/ui'

const linkStyles = css`
  color: ${colors.text.default};
  font-weight: ${typography.fontWeight.bold};
`

export const StyledNativeLink = styled(NativeLink)(linkStyles)
export const StyledLink = styled(Link)(linkStyles)

export const ItemContainer = styled.div`
  background-color: ${palette.white};
  border-top: 1px solid ${palette.chrome};
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: ${spacing.majorScale(5)}px;
  width: 250px;

  > :not(:last-child) {
    margin-bottom: ${spacing.majorScale(3)}px;
  }
`
